/* 1500 Hours · v3 bag (2026-10-13, unpublished theme). Horizon's cart drawer stays the cart: lines, quantities,
   discount codes, checkout and Shop Pay are untouched. This file only ADDS, on every drawer render:
     - the title reads "bag"
     - "o-ring · included" on each card line (presentation only; the order is unchanged)
     - the shipping line: free us shipping, or abroad "N more cards and your cards ship free, worldwide" + meter
     - "your <field> on the rest": the products not in the bag yet, drawn with the bag's field, linking to their
       pages with ?airport= (sizes and colours are picked there; nothing is added from here)
   Config: snippets/h15-bag-config.liquid. Art: the h15-card-render Worker (edge-cached GETs). */
(function () {
  'use strict';
  if (window.__h15bag) return;
  window.__h15bag = true;
  var CFG;
  try { CFG = JSON.parse(document.getElementById('h15bag-cfg').textContent); } catch (e) { return; }

  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function clean(s) { return String(s || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 4); }
  // Shopify hands every price over in the visitor's currency (EUR in France, XOF in Togo ...), so the symbol has to come
  // from Shopify.currency, never a hardcoded "$" (2026-10-23: a Togo visitor read 21,000 XOF as "$21000"). US look unchanged.
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  var NF = {};
  function money(c) {
    c = Math.round(c);
    var k = c % 100 ? 2 : 0;
    try {
      if (!NF[k]) NF[k] = new Intl.NumberFormat('en', { style: 'currency', currency: CUR, minimumFractionDigits: k, maximumFractionDigits: k });
      return NF[k].format(c / 100);
    } catch (e) { return (CUR === 'USD' ? '$' : CUR + ' ') + (k ? (c / 100).toFixed(2) : String(c / 100)); }
  }
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

  /* defs for the strip art, once per page (ids h15g-*) */
  var DEFS = '<svg aria-hidden="true" focusable="false" style="position:absolute;width:0;height:0;overflow:hidden"><defs>' +
    '<mask id="h15g-hole" maskUnits="userSpaceOnUse" x="0" y="0" width="212.5" height="337"><rect width="212.5" height="337" fill="#fff"/><circle cx="25" cy="25" r="7.81" fill="#000"/></mask>' +
    '<radialGradient id="h15g-light" cx="28%" cy="14%" r="95%"><stop offset="0" stop-color="#fff" stop-opacity=".075"/><stop offset=".6" stop-color="#fff" stop-opacity=".02"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></radialGradient>' +
    '<filter id="h15g-ring" x="-25%" y="-25%" width="150%" height="160%" color-interpolation-filters="sRGB"><feGaussianBlur in="SourceAlpha" stdDeviation="1.1"/><feOffset dx=".5" dy="1.4" result="a"/><feFlood flood-color="#141414" flood-opacity=".36"/><feComposite in2="a" operator="in" result="s1"/><feMerge><feMergeNode in="s1"/><feMergeNode in="SourceGraphic"/></feMerge></filter>' +
    '<filter id="h15g-tl" x="-8%" y="-8%" width="116%" height="120%" color-interpolation-filters="sRGB"><feGaussianBlur in="SourceAlpha" stdDeviation="1"/><feOffset dx="0.4" dy="1.1" result="sh"/><feFlood flood-color="#000" flood-opacity="0.5"/><feComposite in2="sh" operator="in" result="shadow"/><feMerge><feMergeNode in="shadow"/><feMergeNode in="SourceGraphic"/></feMerge></filter>' +
    '<filter id="h15g-td" x="-8%" y="-8%" width="116%" height="120%" color-interpolation-filters="sRGB"><feGaussianBlur in="SourceAlpha" stdDeviation="0.9"/><feOffset dx="0.3" dy="0.9" result="sh"/><feFlood flood-color="#3a2a1c" flood-opacity="0.35"/><feComposite in2="sh" operator="in" result="shadow"/><feMerge><feMergeNode in="shadow"/><feMergeNode in="SourceGraphic"/></feMerge></filter>' +
    '</defs></svg>';
  function defs() { if (!document.getElementById('h15g-defs')) { var d = document.createElement('div'); d.id = 'h15g-defs'; d.innerHTML = DEFS; document.body.appendChild(d); } }

  /* Worker art (the homepage's rules) */
  var KEEP = { polygon: ['points'], path: ['d', 'transform'], text: ['x', 'y', 'text-anchor', 'font-weight', 'font-size', 'letter-spacing'] };
  function safeArt(svg) {
    try {
      var doc = new DOMParser().parseFromString(svg, 'image/svg+xml');
      if (doc.querySelector('parsererror')) return '';
      var out = '';
      [].slice.call(doc.querySelectorAll('polygon, path, text')).forEach(function (n) {
        var tag = n.tagName.toLowerCase(), a = '';
        KEEP[tag].forEach(function (k) { var v = n.getAttribute(k); if (v != null) a += ' ' + k + '="' + esc(v) + '"'; });
        out += tag === 'text' ? '<text' + a + '>' + esc(n.textContent) + '</text>' : '<' + tag + a + '/>';
      });
      return out;
    } catch (e) { return ''; }
  }
  var ART = {}, pending = {};
  function art(code) {
    if (ART[code] || pending[code]) return;
    pending[code] = true;
    function get(p) { return fetch(CFG.endpoint + p, { credentials: 'omit' }).then(function (r) { return r.ok ? r.text() : ''; }); }
    Promise.all([get('/?code=' + encodeURIComponent(code)), get('/?m=hat&code=' + encodeURIComponent(code))]).then(function (t) {
      var a = { face: safeArt(t[0]), ink: safeArt(t[1]) };
      if (a.face && a.ink) { ART[code] = a; schedule(); }
    }).catch(function () {}).then(function () { pending[code] = false; });
  }
  var HATBOX = 'left:25.81%;top:27.36%;width:48.46%;height:20.1%', ROPEBOX = 'left:29.58%;top:37.10%;width:40.85%;height:17.83%';
  var GEO = { hoodie: { pct: [33.875, 19.312, 32.25, 42.938] }, crewneck: { pct: [30.875, 11.625, 38.188, 50.812], chest: [1296, 210] } };
  function box(p, mask) { return 'left:' + p[0] + '%;top:' + p[1] + '%;width:' + p[2] + '%;height:' + p[3] + '%' + (mask ? ';-webkit-mask-image:url(' + mask + ');mask-image:url(' + mask + ')' : ''); }
  function itemArt(pid, a) {
    if (pid === 'card') return '<div class="h15bag-card"><svg viewBox="0 0 212.5 337" aria-hidden="true"><image href="' + esc(CFG.ring) + '" x="-53.85" y="214.15" width="111.70" height="111.70" filter="url(#h15g-ring)"/><g mask="url(#h15g-hole)"><rect width="212.5" height="337" rx="12.5" fill="#171717"/><rect width="212.5" height="337" rx="12.5" fill="url(#h15g-light)"/><g fill="#dcdcd7" font-family="Montserrat, sans-serif">' + a.face + '</g></g></svg></div>';
    var obj = '<div class="h15bag-obj"><img alt="" src="' + esc(CFG.cut[pid]) + '">';
    if (pid === 'hat') obj += '<svg class="h15bag-art" style="' + HATBOX + '" viewBox="0 0 400 175" preserveAspectRatio="none" aria-hidden="true"><g fill="#f3f2ee" filter="url(#h15g-tl)">' + a.ink + '</g></svg>';
    if (pid === 'rope') obj += '<svg class="h15bag-art" style="' + ROPEBOX + '" viewBox="0 0 400 175" preserveAspectRatio="none" aria-hidden="true"><g fill="#141414" filter="url(#h15g-td)">' + a.ink + '</g></svg>';
    if (pid === 'hoodie') obj += '<svg class="h15bag-art" style="' + box(GEO.hoodie.pct, CFG.mask) + '" viewBox="0 0 1800 2400" aria-hidden="true"><svg x="167" y="180" width="1466" height="2160" viewBox="18 40 176.5 260" preserveAspectRatio="none"><g fill="#F4F1EA" font-family="Montserrat, sans-serif">' + a.face + '</g></svg></svg>';
    if (pid === 'crewneck') obj += '<svg class="h15bag-art" style="' + box(GEO.crewneck.pct) + '" viewBox="0 0 1800 2400" aria-hidden="true"><svg class="h15bag-chest" data-cx="1296" data-top="210" x="0" y="0" width="0" height="0" viewBox="0 0 400 175" preserveAspectRatio="none"><g fill="#F4F1EA">' + a.ink + '</g></svg></svg>';
    return obj + '</div>';
  }
  function fitChest(host) {
    [].slice.call(host.querySelectorAll('svg.h15bag-chest')).forEach(function (inner) {
      var g = inner.querySelector('g'), bb; try { bb = g.getBBox(); } catch (e) { return; }
      if (!bb || !bb.width) return;
      var w = 450, hh = w * bb.height / bb.width;
      inner.setAttribute('viewBox', bb.x + ' ' + bb.y + ' ' + bb.width + ' ' + bb.height);
      inner.setAttribute('x', 1296 - w / 2); inner.setAttribute('y', 210); inner.setAttribute('width', w); inner.setAttribute('height', hh);
    });
  }

  /* one pass over the drawer */
  function drawer() { return document.querySelector('cart-drawer-component'); }
  var timer = 0;
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 160); }
  function run() {
    var d = drawer(); if (!d) return;
    var head = d.querySelector('#cart-drawer-heading');
    if (head) [].slice.call(head.childNodes).forEach(function (n) { if (n.nodeType === 3 && n.textContent.trim() === 'Cart') n.textContent = n.textContent.replace('Cart', 'bag'); });
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (cart) { if (cart) paint(d, cart); }).catch(function () {});
  }
  function handleOf(href) { var m = String(href || '').match(/\/products\/([^\/?#]+)/); return m ? m[1] : ''; }
  function paint(d, cart) {
    defs();
    // o-ring on every card line (presentation only)
    [].slice.call(d.querySelectorAll('.cart-items__table-row')).forEach(function (tr) {
      var a = tr.querySelector('a.cart-items__title');
      if (!a || CFG.cards.indexOf(handleOf(a.getAttribute('href'))) < 0 || tr.querySelector('.h15-oring')) return;
      var dl = tr.querySelector('dl.cart-items__properties');
      if (!dl) { var w = tr.querySelector('.cart-items__variants-wrapper') || tr.querySelector('.cart-items__details'); if (!w) return; dl = document.createElement('dl'); dl.className = 'cart-items__properties'; w.appendChild(dl); }
      dl.insertAdjacentHTML('beforeend', '<div class="cart-items__property h15-oring"><dt>o-ring:</dt> <dd>included</dd></div>');
    });
    // under the lines, inside the scrolling list (the summary is Horizon's sticky footer; keep it short)
    var host = d.querySelector('.cart-drawer__items') || d.querySelector('.cart-drawer__summary');
    if (!host) return;
    var block = d.querySelector('.h15bag');
    if (!cart.item_count) { if (block) block.remove(); return; }
    var cards = 0, have = {}, code = '';
    cart.items.forEach(function (i) {
      have[i.handle] = 1;
      if (CFG.cards.indexOf(i.handle) > -1) cards += i.quantity;
      if (!code && i.properties && i.properties.Airport) code = clean(i.properties.Airport);
    });
    if (!code) code = clean(lsGet('h15.airport') || '');
    var html = '';
    if (cards) html += '<div class="h15bag-row"><span>gunmetal o-ring' + (cards > 1 ? ', one per card' : '') + '</span><span>included</span></div>';
    if (CFG.country === 'US') html += '<div class="h15bag-row"><span>free us shipping</span><span></span></div>';
    else if (cards) {
      var left = 3 - cards;
      html += '<div class="h15bag-row"><span>' + (left > 0 ? left + ' more card' + (left > 1 ? 's' : '') + ' and your cards ship free, worldwide' : 'your cards ship free, worldwide') + '</span><span></span></div>' +
        '<div class="h15bag-meter"><i style="width:' + Math.min(100, Math.round(cards / 3 * 100)) + '%"></i></div>';
    }
    var o = Date.parse(CFG.opensAt || ''), locked = o && Date.now() < o;
    var rest = (CFG.items || []).filter(function (it) {
      if (have[it.handle] || !it.url || !it.available) return false;
      if ((it.pid === 'hat' || it.pid === 'rope') && (CFG.country !== 'US' || !CFG.hatsLive)) return false;
      if (it.pid === 'card' && CFG.restock) return false;
      return true;
    });
    if (code && rest.length) {
      var a = ART[code];
      if (!a) art(code);
      else html += '<div class="h15bag-xs"><h3>your ' + esc(code) + ' on the rest</h3><div class="h15bag-strip" style="grid-template-columns:repeat(' + rest.length + ',minmax(0,1fr))">' + rest.map(function (it) {
        var price = (it.pid === 'hoodie' || it.pid === 'crewneck') && locked ? 'oct 14' : money(it.price);
        return '<a href="' + esc(it.url) + '?airport=' + encodeURIComponent(code) + '"><div class="h15bag-st">' + itemArt(it.pid, a) + '</div><span>' + esc(it.name) + '</span><span class="h15bag-pr">' + price + '</span></a>';
      }).join('') + '</div></div>';
    }
    var sig = html.length + ':' + html.slice(0, 200) + ':' + cart.item_count + ':' + cards + ':' + code + ':' + rest.length + ':' + !!ART[code];
    if (!block || block.parentNode !== host) { if (block) block.remove(); block = document.createElement('div'); block.className = 'h15bag'; host.appendChild(block); }
    if (block.getAttribute('data-sig') === sig && block.parentNode) return;
    block.setAttribute('data-sig', sig);
    block.innerHTML = html;
    fitChest(block);
  }

  document.addEventListener('cart:update', schedule);
  function watch() {
    var d = drawer(); if (!d) return false;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.closest && t.closest('.h15bag')) continue;   // our own writes
        schedule(); return;
      }
    }).observe(d, { childList: true, subtree: true });
    schedule();
    return true;
  }
  if (!watch()) document.addEventListener('DOMContentLoaded', watch);
})();
